import React, { useState } from 'react';
import { analyticsUtils } from 'utils/analytics-utils';
import { Divider, IconButton, Typography } from 'fronton-react';
import { PlusCircleIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { checkCanReturn } from './utils';
import type { ProductReturnsProps } from './types';
import { root, plusButton, productReturns, textContainer, titleWrapper } from './styles';
import { ProductReturnsModal } from './components';

export const DATA_QA_PRODUCT_RETURNS_BUTTON = 'product-returns-button';

export const ProductReturns: React.FC<ProductReturnsProps> = (props) => {
  const canReturn = props.active || checkCanReturn(props);
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);
  const { t } = useTranslation();
  const onClick = () => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: props.isSet ? 'komplektyDetail' : 'productDetail',
      elementName: 'returnInfo',
      elementText: t('product-returns.block.part1'),
    });
    setModalVisibility(true);
  };

  if (canReturn) {
    return (
      <div className={root} data-testid="product-returns-root-new" data-qa="product-returns-root-new">
        <Divider />
        <div
          onClick={onClick}
          style={{ cursor: 'pointer' }}
          data-qa="product-returns-new"
          className={productReturns}
        >
          <div className={titleWrapper} data-qa="product-returns-title">
            <Typography size="body_accent" variant="s" color="text-primary">
              {t('product-returns.block.part1')}
            </Typography>
            <Typography variant="caption" color="text-primary" className={textContainer}>
              {t('product-returns.block.part2')}
            </Typography>
          </div>
          <IconButton
            size="l"
            className={plusButton}
            label={t('product-returns.block.more-info')}
            data-qa={DATA_QA_PRODUCT_RETURNS_BUTTON}
          >
            <PlusCircleIcon type="outline" size="l" color="text-primary" />
          </IconButton>
        </div>
        <ProductReturnsModal modalVisibility={modalVisibility} setModalVisibility={setModalVisibility} />
      </div>
    );
  }

  return null;
};
